/**
 * Utility functions for handling asset paths
 */

/**
 * Get the correct public asset path based on the current environment
 * @param {string} path - Relative path to the asset (e.g., 'resources/images/logo.png')
 * @returns {string} - Full path to the asset
 */
export function getPublicAssetPath(path) {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  
  // Use the configured public path from environment variable
  const baseUrl = process.env.VUE_APP_PUBLIC_PATH || '/';
  
  return `${baseUrl}${cleanPath}`;
}

/**
 * Get image path for branding assets
 * @param {string} filename - Image filename (e.g., 'catalog_menu.png')
 * @returns {string} - Full path to the branding image
 */
export function getBrandingImagePath(filename) {
  return getPublicAssetPath(`resources/images/branding/${filename}`);
}